import { Component, Input, inject } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

/**
 * Copies an amount as bare digits — no thousands separators — so it can be
 * pasted straight into a banking payment field.
 */
@Component({
  selector: 'app-copy-rial-button',
  imports: [DecimalPipe, MatButtonModule, MatIconModule, MatTooltipModule],
  template: `
    <button mat-stroked-button type="button" class="copy-btn"
      matTooltip="Copy {{ amount | number }} as plain digits"
      (click)="copy($event)">
      <mat-icon>content_copy</mat-icon> Copy Rial
    </button>
  `,
  styles: `
    .copy-btn {
      height: 32px;
      padding: 0 10px;
      font-size: 12px;
      white-space: nowrap;

      mat-icon { font-size: 16px; width: 16px; height: 16px; margin-inline-end: 4px; }
    }
  `,
})
export class CopyRialButton {
  @Input({ required: true }) amount!: number;

  private clipboard = inject(Clipboard);
  private snackBar = inject(MatSnackBar);

  copy(event: Event): void {
    // The button sits inside clickable rows and cards.
    event.stopPropagation();
    const digits = String(Math.round(this.amount * 10));
    if (this.clipboard.copy(digits)) {
      this.snackBar.open(`Copied ${digits}`, undefined, { duration: 2000 });
    } else {
      this.snackBar.open('Could not copy — select the amount manually', 'Close', { duration: 4000 });
    }
  }
}
